import React, { Fragment } from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import ReactHtmlParser from 'html-react-parser';
import $ from 'jquery';
import { desktopBreakpoint } from '../../../../constants';
import Element from '../../../../components/element';
import { each, isArray } from 'lodash';

class RadioGrid extends React.Component {
  constructor(props) {
    super(props);

    this.tableRows = this.tableRows.bind(this);
    this.tableHeader = this.tableHeader.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.mobileGrid = this.mobileGrid.bind(this);
    this.updateCSS = this.updateCSS.bind(this);

    const state = {
      noneOfTheAbove: false
    };
    props.yLabels.map(yLabel => (state[yLabel] = null));
    this.state = state;
  }

  handleChange(selectedValue, row) {
    const { storeAnswer, questionId } = this.props;
    const obj = {};
    obj[row] = selectedValue;
    this.setState(obj, () => {
      storeAnswer(questionId, this.state, this.isQuestionAnswered());
      // checkSurveyState(this);
    });
  }

  onNoneCheckChange = e => {
    const { storeAnswer, questionId, routeMap } = this.props;
    this.setState({ noneOfTheAbove: e.target.checked }, () => {
      storeAnswer(
        questionId,
        this.state,
        this.isQuestionAnswered(),
        routeMap,
        'noneOfTheAbove'
      );
    });
  };

  isQuestionAnswered = () => {
    const { noneOfAboveText } = this.props;
    let answered = false;
    if (noneOfAboveText && this.state.noneOfTheAbove) {
      answered = true;
    } else {
      // Logic to select all options available
      let selectedValuesCount = 0;
      const totalKeys = Object.keys(this.state).length - 2; // the 2 items excluded are 'none of the above' and 'answered'
      each(this.state, (value, key) => {
        if (value && key !== 'answered' && key !== 'noneOfTheAbove') {
          selectedValuesCount++;
        }
      });
      if (selectedValuesCount === totalKeys) {
        answered = true;
        selectedValuesCount = 0;
      } else {
        answered = false;
      }
    }
    return answered;
  };

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers);
    } else {
      // storeAnswer(index, this.state);
    }
    // this.props.checkSurveyState(this);
    // $(window).on('resize', this.updateCSS);
    // this.updateCSS();
  }

  updateCSS() {
    this.forceUpdate();
    if (this.props.isMobile) return;
    const contentWidth = $('.main-content').width();
    const tileWidth = contentWidth / (this.props.xLabels.length + 1) - 0.7; // add 1 for emptly left row
    $(`.radio-group-${this.props.index} tr th`).css({
      'min-width': `${tileWidth}px`
    });
  }

  componentWillUnmount() {
    $(window).off('resize', this.updateCSS);
  }

  tableHeader() {
    const { xLabels } = this.props;
    return xLabels.map((xLabel, index) => {
      return <th key={index}>{xLabel}</th>;
    });
  }

  mobileGrids() {
    const { xLabels, yLabels } = this.props;

    return xLabels.map(rows => {
      let row = yLabels.map(cell => <td>{cell}</td>);
      return <tr>{row}</tr>;
    });
  }

  mobileGrid() {
    const { xLabels, yLabels } = this.props;
    return yLabels.map((yLabel, index) => {
      return (
        <table key={index}>
          <tbody>
            <tr>
              <th>{yLabel}</th>
            </tr>
            <RadioGroup
              selectedValue={this.state[yLabel]}
              onChange={e => this.handleChange(e, yLabel)}
            >
              {xLabels.map((xLabel, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <Radio id={`${xLabel} ${yLabel}`} value={`${xLabel}`} />
                      <label htmlFor={`${xLabel} ${yLabel}`}>{xLabel}</label>
                    </td>
                  </tr>
                );
              })}
            </RadioGroup>
          </tbody>
        </table>
      );
    });
  }

  tableRows() {
    const { yLabels, xLabels } = this.props;
    return yLabels.map((rows, index) => {
      let row = xLabels.map((cell, index) => (
        <td className="survey-grid-item" key={index}>
          {' '}
          <RadioGroup
            selectedValue={this.state[rows]}
            onChange={e => this.handleChange(e, rows)}
          >
            <Radio
              id={`${cell} ${rows}`}
              value={`${cell}`}
              disabled={this.state.noneOfTheAbove}
            />
            <label htmlFor={`${cell} ${rows}`} />
          </RadioGroup>
        </td>
      ));
      return (
        <tr key={index} className="survey-radio-grid-row">
          <td className="survey-radio-grid-row-header">
            <span>{rows}</span>
          </td>
          {row}
        </tr>
      );
    });
  }

  render() {
    const { question, questionId, className, noneOfAboveText } = this.props;
    const isMobile = window.innerWidth < desktopBreakpoint;

    return (
      <div className={`${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <div className="row surveys-container collapse">
          <div className="surveys-list survey-radio-group small-12 columns">
            {!isMobile ? (
              <table className={`radio-group-${this.props.index}`}>
                <tbody>
                  <tr>
                    <th />
                    {this.tableHeader()}
                  </tr>
                  {this.tableRows()}
                </tbody>
              </table>
            ) : (
              <Fragment>
                {this.mobileGrid()}
                {/* {this.props.isMobile && (
                  <Fragment>
                    <br />
                    <br />
                  </Fragment>
                )} */}
              </Fragment>
            )}
          </div>
        </div>
        {noneOfAboveText && (
          <Element display="flex" alignItems="center" marginTop="15px">
            <input
              type="checkbox"
              key={`${questionId}_noneOfAboveText`}
              id={`${questionId}_noneOfAboveText`}
              checked={this.state.noneOfTheAbove}
              onChange={this.onNoneCheckChange}
            />
            <Element
              type="label"
              attrs={{ htmlFor: `${questionId}_noneOfAboveText` }}
              marginBottom={0}
              marginLeft="8px"
              fontFamily="GTAM"
              fontSize="18px"
            >
              {noneOfAboveText}
            </Element>
          </Element>
        )}
      </div>
    );
  }
}

export default RadioGrid;
